import { render, staticRenderFns } from "./header-foot.vue?vue&type=template&id=997634c4&scoped=true"
import script from "./header-foot.vue?vue&type=script&lang=js"
export * from "./header-foot.vue?vue&type=script&lang=js"
import style0 from "./header-foot.vue?vue&type=style&index=0&id=997634c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997634c4",
  null
  
)

export default component.exports